/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

import Layout from '../../components/layout'
import Header from '../../components/header'
import style from '../../components/faq.module.css'

export default function FAQ() {
  const [openedQuestionsIds, updateOpenedQuestionIds] = useState([]);
  const [urlQuestion, updateUrlQuestion] = useState(null);

  const questions =[
    {
      q: "How does FileDriver for Chrome extension work?",
      a: <span>The chrome extension is an add-on for your browser that enables you to send files
      from wherever you are by clicking on the FileDriver Icon. It is <span onClick={(e) => onFaqLinkClick(e, 'secured')} className={style.faqLink}>secured</span>, simple to install and has life-changing features like the <span onClick={(e) => onFaqLinkClick(e, 'gmail')} className={style.faqLink}>Gmail integration!</span></span>,
      id: 'how-it-works'
    },
    {
      q: "Is it secured to install the chrome extension?",
      a: `
      Absolutely Yes! The extension is being reviewed by google on every version release to make sure it is secured
      and safe to use. We are working very hard to require only the bare minimum permissions to work.
      `,
      id: 'secured'
    },
    {
      q: "How does FileDriver Works With My Gmail?",
      a: `
      The extension integrates with your Gmail, making it possible to send any file you want seamlessly without leaving your mail!`,
      id: 'gmail'
    },
    {
      q: "What is the max file size I can upload?",
      a: "Files up to 10GB can be uploaded on the free plan and up to 50Gb on the paid packages",
      id: 'size-limit'
    },
    {
      q: "Where can I see the files I sent?",
      a: `If you chose to create a link, you cae use the generated link to get to the download page.
          If you sent the files via FileDriver's email, make sure to add yourself as a recipient to get the link as well.
      `,
      id: 'files-limit'
    }
  ]

  const router = useRouter();

  useEffect(() => {
    if(router) {
      let question = router.query['question'];
      question && updateUrlQuestion(question);
    }
  }, [router])

  useEffect(() => {
    if(urlQuestion) {
      let selectedQuestion = questions.find(q => q.name === urlQuestion);
      selectedQuestion && updateOpenedQuestionIds([...openedQuestionsIds, ...[selectedQuestion.id]])
    }
  }, [urlQuestion])

  function onFaqLinkClick(e, questionName) {
    e.preventDefault();
    e.stopPropagation();
    let selectedQuestion = questions.find(q => q.id === questionName);
    selectedQuestion && updateOpenedQuestionIds([selectedQuestion.id])
  }

  function Question(questionText, updateIsoOpen, isOpen){
    return (
      <dt className={style.question}>
      <button className={style.button} onClick={() => updateIsoOpen(!isOpen)} aria-expanded={false} aria-controls={"faq1_desc"}>
      {questionText}
      </button>
    </dt>
    );
  }

  //When we will want to make the questions collapsable - need to change the ternary false value to 'none',
  // Currently it is alway open per Roy's request
  function Answer(answerText, isOpen){
    return (
      <dd className={style.answer}>
      <p style={{display: isOpen ? 'block' :'none'}} className={style.answer} id={"faq1_desc"}>
        {answerText}
      </p>
    </dd>
    );
  }

  function renderExpandIcon(isQuestionOpened) {
    return (
    <svg className={isQuestionOpened ? style.minimizedIcon : style.expandIcon} width="31" height="17" viewBox="0 0 31 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8305 15.8653L29.6724 1.98535C30.1255 1.53051 30.1249 0.794344 29.6701 0.340099C29.2153 -0.11356 28.4785 -0.112388 28.0248 0.342444L15.007 13.3966L1.98867 0.341856C1.53501 -0.112975 0.798836 -0.114147 0.344004 0.339512C0.116003 0.566927 0.00170895 0.865264 0.00170893 1.1636C0.00170892 1.46076 0.114832 1.75793 0.341661 1.98534L14.183 15.8659C14.401 16.0851 14.6976 16.2076 15.0065 16.2076C15.3159 16.2076 15.6119 16.0839 15.8305 15.8653Z" fill="white"/>
    </svg>

    );
  }
  function onQuestionClick(id) {
    let updatedQuestions = openedQuestionsIds.includes(id) ? openedQuestionsIds.filter(i => i !== id) : [...openedQuestionsIds, ...[id]];
    updateOpenedQuestionIds(updatedQuestions);
  }

  function renderQuestion(questionObject) {
    let id = questionObject.id;
    let isQuestionOpened = openedQuestionsIds.includes(id);
    return (
      <div role='button' onClick={() => onQuestionClick(id)} className={isQuestionOpened ? style.questionContainerOpened : style.questionContainer}>
      <div className={isQuestionOpened ? style.contentWrapperOpened : style.contentWrapper}>
        <div className={isQuestionOpened ? style.questionContentOpened : style.questionContent}>
         <span className={style.questionTitle}>
         {questionObject.q}
         </span>
         <span className={isQuestionOpened ? style.questionAnswerOpened : style.questionAnswer}>
         {questionObject.a}
         </span>
      </div>
      {renderExpandIcon(isQuestionOpened)}
        </div>
    </div>
    );
  }

  function renderQuestions() {
    return (
      questions.map(q => {
        return renderQuestion(q);
      })
    )
  }

    return (
      <React.Fragment>
      <title>FAQ</title>
    <div className={style.container}>
    <Layout extendedStyle={{borderBottom: '1px solid #434571'}}>
      <Header headerStyle={{width: 'max-content'}}/>
    </Layout>
      <div className={style.leftBlock}>
      <span className={style.Title}>Frequently Asked Questions</span>
       
        <div className={style.questionsContainer}>
        {renderQuestions()}
        </div>
        
      </div>
      <div className={style.rightBlock}>
       <img className={style.image} src={'/images/faqImage.svg'}></img>
      </div>
        </div>
      </React.Fragment>
    )
  }

  /*
        <h2 className={style.Title}> FAQ </h2>
          <dl className={style.mainContent}>
            {Question("What is the max file size I can upload?", updateIsQuestionOpen, isQuestionOpen)}
            {Answer("Files up to 10GB can be uploaded on the free plan. Check out our different plans if you need more", isQuestionOpen)}
            {Question("What types of files can I upload?", updateIsQ2Open, isQ2Open)}
            {Answer("We believe in type equivalence. Files from all types can be uploaded to FileDriver.com", isQ2Open)}
            {Question("How long are the files stored on the servers?", updateIsQ3Open, isQ3Open)}
            {Answer("The files are stored on the servers for a period of 7 days on the free plan. Check out our different plans if you need more", isQ3Open)}
        </dl>
  */